import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import SpeedDial from '@material-ui/lab/SpeedDial';
import SpeedDialIcon from '@material-ui/lab/SpeedDialIcon';
import SpeedDialAction from '@material-ui/lab/SpeedDialAction';
import DescriptionOutlinedIcon from '@material-ui/icons/DescriptionOutlined';
import PersonAddOutlinedIcon from '@material-ui/icons/PersonAddOutlined';

const useStyles = makeStyles((theme) => ({
  root: {
    height: 100,
    transform: 'translateZ(0px)',
    flexGrow: 1,
  },
  rootEmpty:{
      minHeight:200
  },
  speedDial: {
    position: 'fixed',
    bottom: theme.spacing(2),
    right: theme.spacing(2),
  },
  tooltip: {
    marginTop: "-.01rem",
    fontSize: "1.5rem"
  }
}));


export default function SpeedDialTooltipOpen(props) {
  const {callbackhandler,customerId,security}=props;
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);



  const handleOpen = (event) => {
    console.log("opening speed dial"+event)
    setOpen(true);
  };

  const handleClose = (action) => {
    console.log("closing speed dial")
    setOpen(false);
    if(action!==""){
        callbackhandler(action);
    }
  };

  return (
    (security.add_customer || security.add_invoice)&&
    <div style={{height:80}}>
      <SpeedDial
        ariaLabel="SpeedDial tooltip example"
        className={classes.speedDial}
        icon={<SpeedDialIcon />}
        onClose={()=>{handleClose("")}}
        onOpen={handleOpen}
        open={open}
      >
        {security.add_customer&&<SpeedDialAction key="Customer..." icon={<PersonAddOutlinedIcon />} tooltipTitle="Customer...." TooltipClasses={classes} tooltipOpen onClick={()=>{handleClose("customer")}}/>}
        {security.add_invoice&&customerId&&<SpeedDialAction key="Invoice..." icon={<DescriptionOutlinedIcon />} tooltipTitle="Invoice...." TooltipClasses={classes} tooltipOpen onClick={()=>{handleClose("invoice")}}/>}
      </SpeedDial>
    </div>
  );
}
